"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DIMENSION_ANONYMOUS_ID = exports.DIMENSION_MEMBER_ID = exports.DIMENSION_ROLE = exports.DIMENSION_ARTICLE_ID = exports.DIMENSION_CHANNEL_NAME = exports.DIMENSION_SECTION_NAME = exports.DIMENSION_ARTICLE_AUTHOR = void 0;
var DIMENSION_ARTICLE_AUTHOR = 1; //dimension1

exports.DIMENSION_ARTICLE_AUTHOR = DIMENSION_ARTICLE_AUTHOR;
var DIMENSION_SECTION_NAME = 2; // dimension2

exports.DIMENSION_SECTION_NAME = DIMENSION_SECTION_NAME;
var DIMENSION_CHANNEL_NAME = 3; // dimension3

exports.DIMENSION_CHANNEL_NAME = DIMENSION_CHANNEL_NAME;
var DIMENSION_ARTICLE_ID = 5; // dimension5

exports.DIMENSION_ARTICLE_ID = DIMENSION_ARTICLE_ID;
var DIMENSION_ROLE = 6; // dimension6: Member/Anonymous

exports.DIMENSION_ROLE = DIMENSION_ROLE;
var DIMENSION_MEMBER_ID = 7; // dimension7/9

exports.DIMENSION_MEMBER_ID = DIMENSION_MEMBER_ID;
var DIMENSION_ANONYMOUS_ID = 8; // dimension8

exports.DIMENSION_ANONYMOUS_ID = DIMENSION_ANONYMOUS_ID;